<template>
  <b-row class="match-height">
    <b-col sm="12" md="12" xl="12">
      <b-card>
        <div class="loading_page" v-if="loading">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <div class="d-flex justify-content-center mb-3 border p-1">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-content-center mb-2">
              <feather-icon size="33" icon="BarChartIcon" />
            </div>
            <div class="d-flex flex-row justify-content-center">
              <h2 class="bold">{{ $t('Categories Statistics') }}</h2>
            </div>
            <div class="d-flex flex-row justify-content-center mt-2">
              <div v-for="state in [
                {
                  name: $t('Working Engine'),
                  color: '#04d600'
                },
                {
                  name: $t('Stopped Engine'),
                  color: '#FF1405'
                },
                {
                  name: $t('Offline'),
                  color: '#D6D5D5'
                }
              ]" class="d-flex flex-column mx-2">
                <div class="d-flex flex-row">
                  <div class="flex-column rounded"
                    :style="`width: 20px;height: 20px;background-color: ${state.color};`">
                  </div>
                  <div class="flex-column" style="margin-inline: 8px;">
                    <p>{{ $t(state.name) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-row class="match-height">
          <b-col v-for="(item, index) in data" :key="index" sm="12" md="2" xl="2">
            <devices-statistics-by-category-card :data="item" />
          </b-col>
        </b-row>
      </b-card>
    </b-col>


  </b-row>
</template>

<script>
import {
  BFormGroup, BCard, BCardHeader,
  BCardTitle, BCardText, BCardBody,
  BRow, BCol, BMedia, BMediaAside,
  BAvatar, BMediaBody, BLink, BContainer, BTable, BPagination, BFormSelect, BButton, VBTooltip,
  BProgress,
  BBadge
} from 'bootstrap-vue'

import DevicesStatisticsByCategoryCard from './DevicesStatisticsByCategoryCard.vue'

import TableWidget from './modals/TableWidget.vue';
import { OrbitSpinner } from 'epic-spinners'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BContainer,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    OrbitSpinner,
    TableWidget,
    VueApexCharts,
    BProgress,
    BBadge,
    DevicesStatisticsByCategoryCard
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { root }) {

    return {}
  }
}
</script>